// Exported JSON data lives ONLY here
export const classData = {
    kids: {
      hero: {
        title: "KIDS CLASS",
        subtitle: "",
        backgroundImage:
          "https://files-accl.zohoexternal.com/public/workdrive-external/previewdata/nbkv15038664c8b54402c8e75f3c0aa85f707?orig=true",
      },
      gallery: {
        title: "Kids Gallery",
        images: [
          {
            src:
              "https://cdn.prod.website-files.com/5eea1fd06e21541535c81901/6256ebd82354f3764b2a5c18_Kids-5.jpeg",
            alt: "Kids Dance 1",
          },
          {
            src:
              "https://i.pinimg.com/564x/13/db/38/13db3809d9bdf410de0ffcf8e4012533.jpg",
            alt: "Kids Dance 2",
          },
          {
            src:
              "https://www.shutterstock.com/image-photo/athlete-asian-sportswoman-jumping-dance-600nw-2184753393.jpg",
            alt: "Kids Dance 3",
          },
          {
            src:
              "https://static.wixstatic.com/media/c8c956_4a9ae9ec04644ec6890c4dd198952cce~mv2.jpeg/v1/fill/w_980,h_1307,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/c8c956_4a9ae9ec04644ec6890c4dd198952cce~mv2.jpeg",
            alt: "Kids Dance 4",
          },
          {
            src:
              "https://islarosedanceacademy.com/wp-content/uploads/2023/07/IRDA-Clases-Privadas.jpg",
            alt: "Kids Dance 5",
          },
          {
            src: "https://placehold.co/600x400/33FFF5/white?text=Kids+Image+6",
            alt: "Kids Dance 6",
          },
          {
            src: "https://placehold.co/600x400/FF8C33/white?text=Kids+Image+7",
            alt: "Kids Dance 7",
          },
          {
            src: "https://placehold.co/600x400/8CFF33/white?text=Kids+Image+8",
            alt: "Kids Dance 8",
          },
          {
            src: "https://placehold.co/600x400/338CFF/white?text=Kids+Image+9",
            alt: "Kids Dance 9",
          },
          {
            src: "https://placehold.co/600x400/FF3333/white?text=Kids+Image+10",
            alt: "Kids Dance 10",
          },
        ],
      },
      layout: {
        menuItems: [
          { id: "introduction", label: "INTRODUCTION" },
          { id: "fundamentals", label: "FUNDAMENTALS" },
          { id: "dance-fusion", label: "DANCE FUSION" },
          { id: "performance", label: "PERFORMANCE" },
        ],
        contentData: {
          introduction: {
            title: "Start Strong with Kids Dance",
            text:
              "Our “Introduction to Kids Dance” sessions are made with young beginners in mind, offering a warm, welcoming, and fun atmosphere to get them moving. We focus on teaching essential techniques such as basic footwork, body awareness, timing, and how to interpret music through motion. As they progress, they’ll develop not only coordination but also a deep appreciation for the art of dance. With supportive instructors by their side, they’ll build confidence at their own pace and leave each class feeling energized and inspired. This is your invitation to start dancing—one step at a time.",
            imageSrc:
              "https://placehold.co/1000x600/0000FF/white?text=Kids+Dance+Intro",
          },
          fundamentals: {
            title: "Fundamentals of Kids Dance",
            text:
              "Dive deep into the core principles of dance for children. This section covers essential techniques, body posture, and basic movements that form the foundation of all dance styles, adapted for young learners. Perfect for building a strong base.",
            imageSrc:
              "https://placehold.co/1000x600/FF0000/white?text=Kids+Fundamentals",
          },
          "dance-fusion": {
            title: "Kids Dance Fusion: Blending Styles",
            text:
              "Explore the exciting world of dance fusion, where different dance styles are combined to create unique and dynamic performances for kids. Learn how to seamlessly blend various techniques and express themselves creatively.",
            imageSrc:
              "https://placehold.co/1000x600/00FF00/white?text=Kids+Fusion",
          },
          performance: {
            title: "Kids Performance & Choreography",
            text:
              "Take your child's skills to the stage! This section focuses on performance techniques, stage presence, and the art of choreography, tailored for young performers. Learn how to tell a story through movement and captivate your audience.",
            imageSrc:
              "https://placehold.co/1000x600/FFFF00/black?text=Kids+Performance",
          },
        },
      },
      videos: {
        title: "Kids Videos",
        videoLinks: [
          {
            src: "https://www.youtube.com/embed/VIDEO_ID_KIDS_1",
            title: "Kids Dance Fun",
          },
          {
            src: "https://www.youtube.com/embed/VIDEO_ID_KIDS_2",
            title: "Little Dancers",
          },
          {
            src: "https://www.youtube.com/embed/VIDEO_ID_KIDS_3",
            title: "Kids Choreography",
          },
          {
            src: "https://www.youtube.com/embed/VIDEO_ID_KIDS_4",
            title: "Kids Class Highlights",
          },
        ],
      },
    },
    adult: {
      hero: {
        title: "ADULT CLASS",
        subtitle: "",
        backgroundImage:
          "https://i.pinimg.com/originals/13/db/38/13db3809d9bdf410de0ffcf8e4012533.jpg",
      },
      gallery: {
        title: "Adult Gallery",
        images: [
          {
            src:
              "https://i.pinimg.com/236x/13/db/38/13db3809d9bdf410de0ffcf8e4012533.jpg",
            alt: "Adult Dance 1",
          },
          {
            src:
              "https://www.shutterstock.com/image-photo/athlete-asian-sportswoman-jumping-dance-600nw-2184753393.jpg",
            alt: "Adult Dance 2",
          },
          {
            src:
              "https://static.wixstatic.com/media/c8c956_4a9ae9ec04644ec6890c4dd198952cce~mv2.jpeg/v1/fill/w_980,h_1307,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/c8c956_4a9ae9ec04644ec6890c4dd198952cce~mv2.jpeg",
            alt: "Adult Dance 3",
          },
          {
            src:
              "https://islarosedanceacademy.com/wp-content/uploads/2023/07/IRDA-Clases-Privadas.jpg",
            alt: "Adult Dance 4",
          },
          {
            src:
              "https://placehold.co/600x400/FF5733/white?text=Adult+Image+5",
            alt: "Adult Dance 5",
          },
          {
            src:
              "https://placehold.co/600x400/33FF57/white?text=Adult+Image+6",
            alt: "Adult Dance 6",
          },
          {
            src:
              "https://placehold.co/600x400/3357FF/white?text=Adult+Image+7",
            alt: "Adult Dance 7",
          },
          {
            src:
              "https://placehold.co/600x400/FF33A1/white?text=Adult+Image+8",
            alt: "Adult Dance 8",
          },
          {
            src:
              "https://placehold.co/600x400/A133FF/white?text=Adult+Image+9",
            alt: "Adult Dance 9",
          },
          {
            src:
              "https://placehold.co/600x400/33FFF5/white?text=Adult+Image+10",
            alt: "Adult Dance 10",
          },
        ],
      },
      layout: {
        menuItems: [
          { id: "introduction", label: "INTRO TO ADULT DANCE" },
          { id: "fundamentals", label: "ADVANCED TECHNIQUES" },
          { id: "dance-fusion", label: "CONTEMPORARY FUSION" },
          { id: "performance", label: "PROFESSIONAL CHOREOGRAPHY" },
        ],
        contentData: {
          introduction: {
            title: "Discover Your Rhythm",
            text:
              "Our adult dance classes cater to all levels, from absolute beginners to experienced dancers looking to refine their skills. We offer a diverse range of styles, focusing on technique, musicality, and self-expression. Join a vibrant community and rediscover the joy of movement.",
            imageSrc:
              "https://placehold.co/1000x600/0000FF/white?text=Adult+Dance+Intro",
          },
          fundamentals: {
            title: "Mastering Advanced Techniques",
            text:
              "This section is designed for dancers who want to push their boundaries. We delve into intricate footwork, complex turns, and advanced body isolations, ensuring a comprehensive understanding of sophisticated dance movements.",
            imageSrc:
              "https://placehold.co/1000x600/FF0000/white?text=Adult+Fundamentals",
          },
          "dance-fusion": {
            title: "Contemporary Fusion",
            text:
              "Explore the innovative world of contemporary dance, blending elements from various genres like ballet, jazz, and modern. This class encourages creative exploration and fluid movement, allowing dancers to develop their unique artistic voice.",
            imageSrc:
              "https://placehold.co/1000x600/00FF00/white?text=Adult+Fusion",
          },
          performance: {
            title: "Professional Choreography",
            text:
              "Elevate your performance skills with our choreography-focused sessions. Learn complex routines, enhance your stage presence, and prepare for showcases or personal projects. This class is perfect for those aspiring to perform.",
            imageSrc:
              "https://placehold.co/1000x600/FFFF00/black?text=Adult+Performance",
          },
        },
      },
      videos: {
        title: "Adult Videos",
        videoLinks: [
          {
            src: "https://www.youtube.com/embed/VIDEO_ID_ADULT_1",
            title: "Adult Dance Class",
          },
          {
            src: "https://www.youtube.com/embed/VIDEO_ID_ADULT_2",
            title: "Contemporary Flow",
          },
          {
            src: "https://www.youtube.com/embed/VIDEO_ID_ADULT_3",
            title: "Adult Choreography",
          },
          {
            src: "https://www.youtube.com/embed/VIDEO_ID_ADULT_4",
            title: "Advanced Dance Moves",
          },
        ],
      },
    },
    fitness: {
      hero: {
        title: "FITNESS CLASS",
        subtitle: "",
        backgroundImage:
          "https://www.shutterstock.com/image-photo/athlete-asian-sportswoman-jumping-dance-600nw-2184753393.jpg", // Example fitness image
      },
      gallery: {
        title: "Fitness Gallery",
        images: [
          {
            src:
              "https://www.shutterstock.com/image-photo/athlete-asian-sportswoman-jumping-dance-600nw-2184753393.jpg",
            alt: "Fitness 1",
          },
          {
            src:
              "https://placehold.co/600x400/FF5733/white?text=Fitness+Image+2",
            alt: "Fitness 2",
          },
          {
            src:
              "https://placehold.co/600x400/33FF57/white?text=Fitness+Image+3",
            alt: "Fitness 3",
          },
          {
            src:
              "https://placehold.co/600x400/3357FF/white?text=Fitness+Image+4",
            alt: "Fitness 4",
          },
          {
            src:
              "https://placehold.co/600x400/FF33A1/white?text=Fitness+Image+5",
            alt: "Fitness 5",
          },
          {
            src:
              "https://placehold.co/600x400/A133FF/white?text=Fitness+Image+6",
            alt: "Fitness 6",
          },
          {
            src:
              "https://placehold.co/600x400/33FFF5/white?text=Fitness+Image+7",
            alt: "Fitness 7",
          },
          {
            src:
              "https://placehold.co/600x400/FF8C33/white?text=Fitness+Image+8",
            alt: "Fitness 8",
          },
          {
            src:
              "https://placehold.co/600x400/8CFF33/white?text=Fitness+Image+9",
            alt: "Fitness 9",
          },
          {
            src:
              "https://placehold.co/600x400/338CFF/white?text=Fitness+Image+10",
            alt: "Fitness 10",
          },
        ],
      },
      layout: {
        menuItems: [
          { id: "introduction", label: "FITNESS BASICS" },
          { id: "fundamentals", label: "CARDIO DANCE" },
          { id: "dance-fusion", label: "STRENGTH & FLEXIBILITY" },
          { id: "performance", label: "HIGH-INTENSITY WORKOUTS" },
        ],
        contentData: {
          introduction: {
            title: "Get Fit with Dance",
            text:
              "Our fitness classes combine the joy of dance with effective workout routines. Improve your cardiovascular health, build strength, and increase flexibility in a fun and energetic environment. No prior dance experience is needed!",
            imageSrc:
              "https://placehold.co/1000x600/0000FF/white?text=Fitness+Intro",
          },
          fundamentals: {
            title: "Dynamic Cardio Dance",
            text:
              "Ignite your metabolism with our high-energy cardio dance sessions. These classes are designed to get your heart rate up, burn calories, and improve your endurance, all while grooving to upbeat music.",
            imageSrc:
              "https://placehold.co/1000x600/FF0000/white?text=Cardio+Dance",
          },
          "dance-fusion": {
            title: "Strength & Flexibility",
            text:
              "Enhance your physical capabilities with classes focused on building core strength, improving muscle tone, and increasing your range of motion. Incorporating elements of Pilates and yoga with dance movements.",
            imageSrc:
              "https://placehold.co/1000x600/00FF00/white?text=Strength+Flexibility",
          },
          performance: {
            title: "High-Intensity Dance Workouts",
            text:
              "Challenge yourself with our high-intensity interval training (HIIT) dance workouts. These sessions are designed to maximize calorie burn and improve overall fitness in a short amount of time.",
            imageSrc:
              "https://placehold.co/1000x600/FFFF00/black?text=HIIT+Dance",
          },
        },
      },
      videos: {
        title: "Fitness Videos",
        videoLinks: [
          {
            src: "https://www.youtube.com/embed/VIDEO_ID_FITNESS_1",
            title: "Dance Fitness Routine",
          },
          {
            src: "https://www.youtube.com/embed/VIDEO_ID_FITNESS_2",
            title: "Cardio Dance Workout",
          },
          {
            src: "https://www.youtube.com/embed/VIDEO_ID_FITNESS_3",
            title: "Full Body Dance Fitness",
          },
          {
            src: "https://www.youtube.com/embed/VIDEO_ID_FITNESS_4",
            title: "Zumba Class Highlights",
          },
        ],
      },
    },
    online: {
      hero: {
        title: "ONLINE CLASS",
        subtitle: "",
        backgroundImage:
          "https://static.wixstatic.com/media/c8c956_4a9ae9ec04644ec6890c4dd198952cce~mv2.jpeg/v1/fill/w_980,h_1307,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/c8c956_4a9ae9ec04644ec6890c4dd198952cce~mv2.jpeg", // Example online image
      },
      gallery: {
        title: "Online Gallery",
        images: [
          {
            src:
              "https://static.wixstatic.com/media/c8c956_4a9ae9ec04644ec6890c4dd198952cce~mv2.jpeg/v1/fill/w_980,h_1307,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/c8c956_4a9ae9ec04644ec6890c4dd198952cce~mv2.jpeg",
            alt: "Online Class 1",
          },
          {
            src:
              "https://placehold.co/600x400/FF5733/white?text=Online+Image+2",
            alt: "Online Class 2",
          },
          {
            src:
              "https://placehold.co/600x400/33FF57/white?text=Online+Image+3",
            alt: "Online Class 3",
          },
          {
            src:
              "https://placehold.co/600x400/3357FF/white?text=Online+Image+4",
            alt: "Online Class 4",
          },
          {
            src:
              "https://placehold.co/600x400/FF33A1/white?text=Online+Image+5",
            alt: "Online Class 5",
          },
          {
            src:
              "https://placehold.co/600x400/A133FF/white?text=Online+Image+6",
            alt: "Online Class 6",
          },
          {
            src:
              "https://placehold.co/600x400/33FFF5/white?text=Online+Image+7",
            alt: "Online Class 7",
          },
          {
            src:
              "https://placehold.co/600x400/FF8C33/white?text=Online+Image+8",
            alt: "Online Class 8",
          },
          {
            src:
              "https://placehold.co/600x400/8CFF33/white?text=Online+Image+9",
            alt: "Online Class 9",
          },
          {
            src:
              "https://placehold.co/600x400/338CFF/white?text=Online+Image+10",
            alt: "Online Class 10",
          },
        ],
      },
      layout: {
        menuItems: [
          { id: "introduction", label: "ONLINE PLATFORM" },
          { id: "fundamentals", label: "VIRTUAL CLASSES" },
          { id: "dance-fusion", label: "INTERACTIVE SESSIONS" },
          { id: "performance", label: "RECORDED WORKSHOPS" },
        ],
        contentData: {
          introduction: {
            title: "Dance from Anywhere",
            text:
              "Our online classes bring the studio experience directly to your home. Enjoy high-quality instruction and engaging dance sessions from the comfort of your own space, at your own pace. All you need is an internet connection!",
            imageSrc:
              "https://placehold.co/1000x600/0000FF/white?text=Online+Intro",
          },
          fundamentals: {
            title: "Live Virtual Classes",
            text:
              "Participate in real-time virtual dance classes with live instructors. Get personalized feedback and interact with your classmates, just like in a physical studio. Perfect for maintaining your routine.",
            imageSrc:
              "https://placehold.co/1000x600/FF0000/white?text=Virtual+Classes",
          },
          "dance-fusion": {
            title: "Interactive Online Sessions",
            text:
              "Our online sessions are designed to be highly interactive, with opportunities for Q&A, breakout rooms, and collaborative projects. Learn new moves and connect with dancers worldwide.",
            imageSrc:
              "https://placehold.co/1000x600/00FF00/white?text=Interactive+Online",
          },
          performance: {
            title: "On-Demand Workshops",
            text:
              "Access a library of recorded workshops and tutorials at any time. Perfect for reviewing techniques, learning new choreography, or catching up on missed classes. Learn at your convenience.",
            imageSrc:
              "https://placehold.co/1000x600/FFFF00/black?text=On-Demand+Workshops",
          },
        },
      },
      videos: {
        title: "Online Videos",
        videoLinks: [
          {
            src: "https://www.youtube.com/embed/VIDEO_ID_ONLINE_1",
            title: "Online Dance Tutorial",
          },
          {
            src: "https://www.youtube.com/embed/VIDEO_ID_ONLINE_2",
            title: "Virtual Dance Class",
          },
          {
            src: "https://www.youtube.com/embed/VIDEO_ID_ONLINE_3",
            title: "Home Dance Workout",
          },
          {
            src: "https://www.youtube.com/embed/VIDEO_ID_ONLINE_4",
            title: "Online Choreography",
          },
        ],
      },
    },
    private: {
      hero: {
        title: "PRIVATE CLASS",
        subtitle: "",
        backgroundImage:
          "https://islarosedanceacademy.com/wp-content/uploads/2023/07/IRDA-Clases-Privadas.jpg", // Example private image
      },
      gallery: {
        title: "Private Gallery",
        images: [
          {
            src:
              "https://islarosedanceacademy.com/wp-content/uploads/2023/07/IRDA-Clases-Privadas.jpg",
            alt: "Private Class 1",
          },
          {
            src:
              "https://placehold.co/600x400/FF5733/white?text=Private+Image+2",
            alt: "Private Class 2",
          },
          {
            src:
              "https://placehold.co/600x400/33FF57/white?text=Private+Image+3",
            alt: "Private Class 3",
          },
          {
            src:
              "https://placehold.co/600x400/3357FF/white?text=Private+Image+4",
            alt: "Private Class 4",
          },
          {
            src:
              "https://placehold.co/600x400/FF33A1/white?text=Private+Image+5",
            alt: "Private Class 5",
          },
          {
            src:
              "https://placehold.co/600x400/A133FF/white?text=Private+Image+6",
            alt: "Private Class 6",
          },
          {
            src:
              "https://placehold.co/600x400/33FFF5/white?text=Private+Image+7",
            alt: "Private Class 7",
          },
          {
            src:
              "https://placehold.co/600x400/FF8C33/white?text=Private+Image+8",
            alt: "Private Class 8",
          },
          {
            src:
              "https://placehold.co/600x400/8CFF33/white?text=Private+Image+9",
            alt: "Private Class 9",
          },
          {
            src:
              "https://placehold.co/600x400/338CFF/white?text=Private+Image+10",
            alt: "Private Class 10",
          },
        ],
      },
      layout: {
        menuItems: [
          { id: "introduction", label: "PERSONALIZED TRAINING" },
          { id: "fundamentals", label: "CUSTOMIZED CURRICULUM" },
          { id: "dance-fusion", label: "ONE-ON-ONE COACHING" },
          { id: "performance", label: "FLEXIBLE SCHEDULING" },
        ],
        contentData: {
          introduction: {
            title: "Tailored Dance Experience",
            text:
              "Our private classes offer a highly personalized dance experience, designed to meet your specific goals and learning style. Receive one-on-one attention from our expert instructors, allowing for rapid progress and focused development.",
            imageSrc:
              "https://placehold.co/1000x600/0000FF/white?text=Private+Intro",
          },
          fundamentals: {
            title: "Customized Curriculum",
            text:
              "Work with your instructor to create a dance curriculum that's perfectly suited to your needs. Whether you want to master a specific style, prepare for an audition, or simply improve your technique, we'll build a plan just for you.",
            imageSrc:
              "https://placehold.co/1000x600/FF0000/white?text=Custom+Curriculum",
          },
          "dance-fusion": {
            title: "Dedicated One-on-One Coaching",
            text:
              "Benefit from undivided attention and immediate feedback during your private sessions. Our instructors provide detailed guidance, helping you correct form, refine movements, and unlock your full potential.",
            imageSrc:
              "https://placehold.co/1000x600/00FF00/white?text=One-on-One",
          },
          performance: {
            title: "Flexible Scheduling",
            text:
              "Private classes offer unparalleled flexibility to fit your busy schedule. Choose your preferred times and frequency, making it easy to integrate dance training into your life without compromise.",
            imageSrc:
              "https://placehold.co/1000x600/FFFF00/black?text=Flexible+Scheduling",
          },
        },
      },
      videos: {
        title: "Private Videos",
        videoLinks: [
          {
            src: "https://www.youtube.com/embed/VIDEO_ID_PRIVATE_1",
            title: "Private Dance Lesson",
          },
          {
            src: "https://www.youtube.com/embed/VIDEO_ID_PRIVATE_2",
            title: "Personalized Coaching",
          },
          {
            src: "https://www.youtube.com/embed/VIDEO_ID_PRIVATE_3",
            title: "Solo Dance Training",
          },
          {
            src: "https://www.youtube.com/embed/VIDEO_ID_PRIVATE_4",
            title: "Private Session Highlights",
          },
        ],
      },
    },
  };